import React, { useState } from "react";
import {
  CitySelect,
  CountrySelect,
  StateSelect,
} from "react-country-state-city";
import Banner from "../../assets/dregisteration.svg";
import Admin from "../../assets/icon/admin.svg";
import AgencyAddress from "../../assets/icon/agencyaddress.svg";
import Confirmation from "../../assets/icon/confirmation.svg";
// import ReCAPTCHA from "react-google-recaptcha";
import { Modal } from "flowbite-react";
import Login from "./login";
import "react-country-state-city/dist/react-country-state-city.css";

const Registeration = () => {
  const [countryid, setCountryid] = useState(0);
  const [stateid, setstateid] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  console.log();
  return (
    <div className="sectionbg">
      <div className="container mx-auto p-5 pb-20 md:px-8 lg:px-32">
        <div className="grid rounded grid-cols-1 md:grid-cols-3 md:mt-10">
          <div className="md:sticky md:top-0 md:h-screen">
            <img src={Banner} alt="fbtb2b" />
            <h2 className="font-primary font-bold text-2xl mt-4">
              Already FBT B2B Member ?
            </h2>
            <button
              onClick={() => setOpenModal(true)}
              className="w-full hover:bg-[#100a55e5] rounded text-sm font-bold bg-primary my-4 text-white p-2 md:px-7 py-3.5 md:w-auto"
            >
              Log In
            </button>
          </div>
          <div className="col-span-2 pt-10  md:p-10 md:pt-0">
            <h1 className="text-3xl font-bold mb-5 font-primary">
              Agent Registration Form
            </h1>

            <div>
              <form className="mx-auto">
                <div className="flex gap-2 font-bold text-lg mb-2 font-primary">
                  <img src={Admin} alt="fbtb2b" />
                  Admin Details
                </div>
                <div className="grid md:grid-cols-2 md:gap-6">
                  <div className="relative flex z-0 w-full mb-2 group">
                    <select
                      id="countries"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    >
                      <option selected>Mr</option>
                      <option>Miss</option>
                      <option>Mrs</option>
                      <option>Ms</option>
                    </select>
                    <input
                      type="text"
                      id="firstname"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="First Name"
                      required
                    />
                  </div>
                  <div className="relative w-full mb-2 group">
                    <input
                      type="text"
                      id="lastname"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Last Name"
                      required
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 md:gap-6">
                  <div className="relative flex z-0 w-full mb-2 group">
                    <select
                      id="countrycode"
                      className="bg-gray-50 border min-w-24 border-gray-300 text-gray-900 text-sm block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    >
                      <option value="93">AF +93</option>
                      <option value="355">AL +355</option>
                      <option value="213">DZ +213</option>
                      <option value="1684">AS +1684</option>
                      <option value="376">AD +376</option>
                      <option value="244">AO +244</option>
                      <option value="1264">AI +1264</option>
                      <option value="0">AQ +0</option>
                      <option value="1268">AG +1268</option>
                      <option value="54">AR +54</option>
                      <option value="374">AM +374</option>
                      <option value="297">AW +297</option>
                      <option value="61">AU +61</option>
                      <option value="43">AT +43</option>
                      <option value="994">AZ +994</option>
                      <option value="1242">BS +1242</option>
                      <option value="973">BH +973</option>
                      <option value="880">BD +880</option>
                      <option value="1246">BB +1246</option>
                      <option value="375">BY +375</option>
                      <option value="32">BE +32</option>
                      <option value="501">BZ +501</option>
                      <option value="229">BJ +229</option>
                      <option value="1441">BM +1441</option>
                      <option value="975">BT +975</option>
                      <option value="591">BO +591</option>
                      <option value="387">BA +387</option>
                      <option value="267">BW +267</option>
                      <option value="0">BV +0</option>
                      <option value="55">BR +55</option>
                      <option value="246">IO +246</option>
                      <option value="673">BN +673</option>
                      <option value="359">BG +359</option>
                      <option value="226">BF +226</option>
                      <option value="257">BI +257</option>
                      <option value="855">KH +855</option>
                      <option value="237">CM +237</option>
                      <option value="1">CA +1</option>
                      <option value="238">CV +238</option>
                      <option value="1345">KY +1345</option>
                      <option value="236">CF +236</option>
                      <option value="235">TD +235</option>
                      <option value="56">CL +56</option>
                      <option value="86">CN +86</option>
                      <option value="61">CX +61</option>
                      <option value="672">CC +672</option>
                      <option value="57">CO +57</option>
                      <option value="269">KM +269</option>
                      <option value="242">CG +242</option>
                      <option value="242">CD +242</option>
                      <option value="682">CK +682</option>
                      <option value="506">CR +506</option>
                      <option value="225">CI +225</option>
                      <option value="385">HR +385</option>
                      <option value="53">CU +53</option>
                      <option value="357">CY +357</option>
                      <option value="420">CZ +420</option>
                      <option value="45">DK +45</option>
                      <option value="253">DJ +253</option>
                      <option value="1767">DM +1767</option>
                      <option value="1809">DO +1809</option>
                      <option value="670">TP +670</option>
                      <option value="593">EC +593</option>
                      <option value="20">EG +20</option>
                      <option value="503">SV +503</option>
                      <option value="240">GQ +240</option>
                      <option value="291">ER +291</option>
                      <option value="372">EE +372</option>
                      <option value="251">ET +251</option>
                      <option value="61">XA +61</option>
                      <option value="500">FK +500</option>
                      <option value="298">FO +298</option>
                      <option value="679">FJ +679</option>
                      <option value="358">FI +358</option>
                      <option value="33">FR +33</option>
                      <option value="594">GF +594</option>
                      <option value="689">PF +689</option>
                      <option value="0">TF +0</option>
                      <option value="241">GA +241</option>
                      <option value="220">GM +220</option>
                      <option value="995">GE +995</option>
                      <option value="49">DE +49</option>
                      <option value="233">GH +233</option>
                      <option value="350">GI +350</option>
                      <option value="30">GR +30</option>
                      <option value="299">GL +299</option>
                      <option value="1473">GD +1473</option>
                      <option value="590">GP +590</option>
                      <option value="1671">GU +1671</option>
                      <option value="502">GT +502</option>
                      <option value="44">XU +44</option>
                      <option value="224">GN +224</option>
                      <option value="245">GW +245</option>
                      <option value="592">GY +592</option>
                      <option value="509">HT +509</option>
                      <option value="0">HM +0</option>
                      <option value="504">HN +504</option>
                      <option value="852">HK +852</option>
                      <option value="36">HU +36</option>
                      <option value="354">IS +354</option>
                      <option value="91" selected="">
                        IN +91
                      </option>
                      <option value="62">ID +62</option>
                      <option value="98">IR +98</option>
                      <option value="964">IQ +964</option>
                      <option value="353">IE +353</option>
                      <option value="972">IL +972</option>
                      <option value="39">IT +39</option>
                      <option value="1876">JM +1876</option>
                      <option value="81">JP +81</option>
                      <option value="44">XJ +44</option>
                      <option value="962">JO +962</option>
                      <option value="7">KZ +7</option>
                      <option value="254">KE +254</option>
                      <option value="686">KI +686</option>
                      <option value="850">KP +850</option>
                      <option value="82">KR +82</option>
                      <option value="965">KW +965</option>
                      <option value="996">KG +996</option>
                      <option value="856">LA +856</option>
                      <option value="371">LV +371</option>
                      <option value="961">LB +961</option>
                      <option value="266">LS +266</option>
                      <option value="231">LR +231</option>
                      <option value="218">LY +218</option>
                      <option value="423">LI +423</option>
                      <option value="370">LT +370</option>
                      <option value="352">LU +352</option>
                      <option value="853">MO +853</option>
                      <option value="389">MK +389</option>
                      <option value="261">MG +261</option>
                      <option value="265">MW +265</option>
                      <option value="60">MY +60</option>
                      <option value="960">MV +960</option>
                      <option value="223">ML +223</option>
                      <option value="356">MT +356</option>
                      <option value="44">XM +44</option>
                      <option value="692">MH +692</option>
                      <option value="596">MQ +596</option>
                      <option value="222">MR +222</option>
                      <option value="230">MU +230</option>
                      <option value="269">YT +269</option>
                      <option value="52">MX +52</option>
                      <option value="691">FM +691</option>
                      <option value="373">MD +373</option>
                      <option value="377">MC +377</option>
                      <option value="976">MN +976</option>
                      <option value="1664">MS +1664</option>
                      <option value="212">MA +212</option>
                      <option value="258">MZ +258</option>
                      <option value="95">MM +95</option>
                      <option value="264">NA +264</option>
                      <option value="674">NR +674</option>
                      <option value="977">NP +977</option>
                      <option value="599">AN +599</option>
                      <option value="31">NL +31</option>
                      <option value="687">NC +687</option>
                      <option value="64">NZ +64</option>
                      <option value="505">NI +505</option>
                      <option value="227">NE +227</option>
                      <option value="234">NG +234</option>
                      <option value="683">NU +683</option>
                      <option value="672">NF +672</option>
                      <option value="1670">MP +1670</option>
                      <option value="47">NO +47</option>
                      <option value="968">OM +968</option>
                      <option value="92">PK +92</option>
                      <option value="680">PW +680</option>
                      <option value="970">PS +970</option>
                      <option value="507">PA +507</option>
                      <option value="675">PG +675</option>
                      <option value="595">PY +595</option>
                      <option value="51">PE +51</option>
                      <option value="63">PH +63</option>
                      <option value="0">PN +0</option>
                      <option value="48">PL +48</option>
                      <option value="351">PT +351</option>
                      <option value="1787">PR +1787</option>
                      <option value="974">QA +974</option>
                      <option value="262">RE +262</option>
                      <option value="40">RO +40</option>
                      <option value="70">RU +70</option>
                      <option value="250">RW +250</option>
                      <option value="290">SH +290</option>
                      <option value="1869">KN +1869</option>
                      <option value="1758">LC +1758</option>
                      <option value="508">PM +508</option>
                      <option value="1784">VC +1784</option>
                      <option value="684">WS +684</option>
                      <option value="378">SM +378</option>
                      <option value="239">ST +239</option>
                      <option value="966">SA +966</option>
                      <option value="221">SN +221</option>
                      <option value="381">RS +381</option>
                      <option value="248">SC +248</option>
                      <option value="232">SL +232</option>
                      <option value="65">SG +65</option>
                      <option value="421">SK +421</option>
                      <option value="386">SI +386</option>
                      <option value="44">XG +44</option>
                      <option value="677">SB +677</option>
                      <option value="252">SO +252</option>
                      <option value="27">ZA +27</option>
                      <option value="0">GS +0</option>
                      <option value="211">SS +211</option>
                      <option value="34">ES +34</option>
                      <option value="94">LK +94</option>
                      <option value="249">SD +249</option>
                      <option value="597">SR +597</option>
                      <option value="47">SJ +47</option>
                      <option value="268">SZ +268</option>
                      <option value="46">SE +46</option>
                      <option value="41">CH +41</option>
                      <option value="963">SY +963</option>
                      <option value="886">TW +886</option>
                      <option value="992">TJ +992</option>
                      <option value="255">TZ +255</option>
                      <option value="66">TH +66</option>
                      <option value="228">TG +228</option>
                      <option value="690">TK +690</option>
                      <option value="676">TO +676</option>
                      <option value="1868">TT +1868</option>
                      <option value="216">TN +216</option>
                      <option value="90">TR +90</option>
                      <option value="7370">TM +7370</option>
                      <option value="1649">TC +1649</option>
                      <option value="688">TV +688</option>
                      <option value="256">UG +256</option>
                      <option value="380">UA +380</option>
                      <option value="971">AE +971</option>
                      <option value="44">GB +44</option>
                      <option value="1">US +1</option>
                      <option value="1">UM +1</option>
                      <option value="598">UY +598</option>
                      <option value="998">UZ +998</option>
                      <option value="678">VU +678</option>
                      <option value="39">VA +39</option>
                      <option value="58">VE +58</option>
                      <option value="84">VN +84</option>
                      <option value="1284">VG +1284</option>
                      <option value="1340">VI +1340</option>
                      <option value="681">WF +681</option>
                      <option value="212">EH +212</option>
                      <option value="967">YE +967</option>
                      <option value="38">YU +38</option>
                      <option value="260">ZM +260</option>
                      <option value="263">ZW +263</option>
                    </select>
                    <input
                      type="number"
                      id="phonenumber"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Phone Number"
                      required
                    />
                  </div>
                  <div className="relative w-full mb-2 group">
                    <input
                      type="email"
                      id="emailid"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Email Id"
                      required
                    />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 md:gap-6">
                  <div className="relative w-full mb-2 group">
                    <span className="h-28">
                      <select
                        id="currency"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      >
                        <option selected>Preferred Currency</option>
                        <option>AED</option>
                        <option>AUD</option>
                        <option>BHD</option>
                        <option>CAD</option>
                        <option>CHF</option>
                        <option>CNY</option>
                        <option>EGP</option>
                        <option>EUR</option>
                        <option>GBP</option>
                        <option>INR</option>
                        <option>KWD</option>
                        <option>MAD</option>
                        <option>MYR</option>
                        <option>NPR</option>
                        <option>NZD</option>
                        <option>OMR</option>
                        <option>QAR</option>
                        <option>SAR</option>
                        <option>THB</option>
                      </select>
                    </span>
                  </div>
                  <div className="relative flex z-0 w-full mb-2 group">
                    <input
                      type="number"
                      id="whatsapp"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Whatsapp Number"
                      required
                    />
                  </div>
                </div>

                <div className="flex gap-2 font-bold text-lg my-2 font-primary">
                  <img src={Admin} alt="fbtb2b" />
                  Agency Details
                </div>
                <span className="text-sm flex items-center gap-1 mb-2">
                  <input
                    id="default-checkbox"
                    type="checkbox"
                    value="Phone number and Email ID same as Admin Details"
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                  ></input>
                  Phone number and Email ID same as Admin Details
                </span>
                <div className="grid md:grid-cols-2 md:gap-6">
                  <div className="relative w-full mb-2 group">
                    <input
                      type="text"
                      id="agencyname"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Agency Name"
                      required
                    />
                  </div>
                  <div className="relative w-full mb-2 group">
                    <input
                      type="email"
                      id="agencyemail"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Email Id"
                      required
                    />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 md:gap-6">
                  <div className="relative flex z-0 w-full mb-2 group">
                    <select
                      id="countrycode"
                      className="bg-gray-50 border min-w-24 border-gray-300 text-gray-900 text-sm block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    >
                      <option value="93">AF +93</option>
                      <option value="355">AL +355</option>
                      <option value="213">DZ +213</option>
                      <option value="1684">AS +1684</option>
                      <option value="376">AD +376</option>
                      <option value="244">AO +244</option>
                      <option value="1264">AI +1264</option>
                      <option value="0">AQ +0</option>
                      <option value="1268">AG +1268</option>
                      <option value="54">AR +54</option>
                      <option value="374">AM +374</option>
                      <option value="297">AW +297</option>
                      <option value="61">AU +61</option>
                      <option value="43">AT +43</option>
                      <option value="994">AZ +994</option>
                      <option value="1242">BS +1242</option>
                      <option value="973">BH +973</option>
                      <option value="880">BD +880</option>
                      <option value="1246">BB +1246</option>
                      <option value="375">BY +375</option>
                      <option value="32">BE +32</option>
                      <option value="501">BZ +501</option>
                      <option value="229">BJ +229</option>
                      <option value="1441">BM +1441</option>
                      <option value="975">BT +975</option>
                      <option value="591">BO +591</option>
                      <option value="387">BA +387</option>
                      <option value="267">BW +267</option>
                      <option value="0">BV +0</option>
                      <option value="55">BR +55</option>
                      <option value="246">IO +246</option>
                      <option value="673">BN +673</option>
                      <option value="359">BG +359</option>
                      <option value="226">BF +226</option>
                      <option value="257">BI +257</option>
                      <option value="855">KH +855</option>
                      <option value="237">CM +237</option>
                      <option value="1">CA +1</option>
                      <option value="238">CV +238</option>
                      <option value="1345">KY +1345</option>
                      <option value="236">CF +236</option>
                      <option value="235">TD +235</option>
                      <option value="56">CL +56</option>
                      <option value="86">CN +86</option>
                      <option value="61">CX +61</option>
                      <option value="672">CC +672</option>
                      <option value="57">CO +57</option>
                      <option value="269">KM +269</option>
                      <option value="242">CG +242</option>
                      <option value="242">CD +242</option>
                      <option value="682">CK +682</option>
                      <option value="506">CR +506</option>
                      <option value="225">CI +225</option>
                      <option value="385">HR +385</option>
                      <option value="53">CU +53</option>
                      <option value="357">CY +357</option>
                      <option value="420">CZ +420</option>
                      <option value="45">DK +45</option>
                      <option value="253">DJ +253</option>
                      <option value="1767">DM +1767</option>
                      <option value="1809">DO +1809</option>
                      <option value="670">TP +670</option>
                      <option value="593">EC +593</option>
                      <option value="20">EG +20</option>
                      <option value="503">SV +503</option>
                      <option value="240">GQ +240</option>
                      <option value="291">ER +291</option>
                      <option value="372">EE +372</option>
                      <option value="251">ET +251</option>
                      <option value="61">XA +61</option>
                      <option value="500">FK +500</option>
                      <option value="298">FO +298</option>
                      <option value="679">FJ +679</option>
                      <option value="358">FI +358</option>
                      <option value="33">FR +33</option>
                      <option value="594">GF +594</option>
                      <option value="689">PF +689</option>
                      <option value="0">TF +0</option>
                      <option value="241">GA +241</option>
                      <option value="220">GM +220</option>
                      <option value="995">GE +995</option>
                      <option value="49">DE +49</option>
                      <option value="233">GH +233</option>
                      <option value="350">GI +350</option>
                      <option value="30">GR +30</option>
                      <option value="299">GL +299</option>
                      <option value="1473">GD +1473</option>
                      <option value="590">GP +590</option>
                      <option value="1671">GU +1671</option>
                      <option value="502">GT +502</option>
                      <option value="44">XU +44</option>
                      <option value="224">GN +224</option>
                      <option value="245">GW +245</option>
                      <option value="592">GY +592</option>
                      <option value="509">HT +509</option>
                      <option value="0">HM +0</option>
                      <option value="504">HN +504</option>
                      <option value="852">HK +852</option>
                      <option value="36">HU +36</option>
                      <option value="354">IS +354</option>
                      <option value="91" selected="">
                        IN +91
                      </option>
                      <option value="62">ID +62</option>
                      <option value="98">IR +98</option>
                      <option value="964">IQ +964</option>
                      <option value="353">IE +353</option>
                      <option value="972">IL +972</option>
                      <option value="39">IT +39</option>
                      <option value="1876">JM +1876</option>
                      <option value="81">JP +81</option>
                      <option value="44">XJ +44</option>
                      <option value="962">JO +962</option>
                      <option value="7">KZ +7</option>
                      <option value="254">KE +254</option>
                      <option value="686">KI +686</option>
                      <option value="850">KP +850</option>
                      <option value="82">KR +82</option>
                      <option value="965">KW +965</option>
                      <option value="996">KG +996</option>
                      <option value="856">LA +856</option>
                      <option value="371">LV +371</option>
                      <option value="961">LB +961</option>
                      <option value="266">LS +266</option>
                      <option value="231">LR +231</option>
                      <option value="218">LY +218</option>
                      <option value="423">LI +423</option>
                      <option value="370">LT +370</option>
                      <option value="352">LU +352</option>
                      <option value="853">MO +853</option>
                      <option value="389">MK +389</option>
                      <option value="261">MG +261</option>
                      <option value="265">MW +265</option>
                      <option value="60">MY +60</option>
                      <option value="960">MV +960</option>
                      <option value="223">ML +223</option>
                      <option value="356">MT +356</option>
                      <option value="44">XM +44</option>
                      <option value="692">MH +692</option>
                      <option value="596">MQ +596</option>
                      <option value="222">MR +222</option>
                      <option value="230">MU +230</option>
                      <option value="269">YT +269</option>
                      <option value="52">MX +52</option>
                      <option value="691">FM +691</option>
                      <option value="373">MD +373</option>
                      <option value="377">MC +377</option>
                      <option value="976">MN +976</option>
                      <option value="1664">MS +1664</option>
                      <option value="212">MA +212</option>
                      <option value="258">MZ +258</option>
                      <option value="95">MM +95</option>
                      <option value="264">NA +264</option>
                      <option value="674">NR +674</option>
                      <option value="977">NP +977</option>
                      <option value="599">AN +599</option>
                      <option value="31">NL +31</option>
                      <option value="687">NC +687</option>
                      <option value="64">NZ +64</option>
                      <option value="505">NI +505</option>
                      <option value="227">NE +227</option>
                      <option value="234">NG +234</option>
                      <option value="683">NU +683</option>
                      <option value="672">NF +672</option>
                      <option value="1670">MP +1670</option>
                      <option value="47">NO +47</option>
                      <option value="968">OM +968</option>
                      <option value="92">PK +92</option>
                      <option value="680">PW +680</option>
                      <option value="970">PS +970</option>
                      <option value="507">PA +507</option>
                      <option value="675">PG +675</option>
                      <option value="595">PY +595</option>
                      <option value="51">PE +51</option>
                      <option value="63">PH +63</option>
                      <option value="0">PN +0</option>
                      <option value="48">PL +48</option>
                      <option value="351">PT +351</option>
                      <option value="1787">PR +1787</option>
                      <option value="974">QA +974</option>
                      <option value="262">RE +262</option>
                      <option value="40">RO +40</option>
                      <option value="70">RU +70</option>
                      <option value="250">RW +250</option>
                      <option value="290">SH +290</option>
                      <option value="1869">KN +1869</option>
                      <option value="1758">LC +1758</option>
                      <option value="508">PM +508</option>
                      <option value="1784">VC +1784</option>
                      <option value="684">WS +684</option>
                      <option value="378">SM +378</option>
                      <option value="239">ST +239</option>
                      <option value="966">SA +966</option>
                      <option value="221">SN +221</option>
                      <option value="381">RS +381</option>
                      <option value="248">SC +248</option>
                      <option value="232">SL +232</option>
                      <option value="65">SG +65</option>
                      <option value="421">SK +421</option>
                      <option value="386">SI +386</option>
                      <option value="44">XG +44</option>
                      <option value="677">SB +677</option>
                      <option value="252">SO +252</option>
                      <option value="27">ZA +27</option>
                      <option value="0">GS +0</option>
                      <option value="211">SS +211</option>
                      <option value="34">ES +34</option>
                      <option value="94">LK +94</option>
                      <option value="249">SD +249</option>
                      <option value="597">SR +597</option>
                      <option value="47">SJ +47</option>
                      <option value="268">SZ +268</option>
                      <option value="46">SE +46</option>
                      <option value="41">CH +41</option>
                      <option value="963">SY +963</option>
                      <option value="886">TW +886</option>
                      <option value="992">TJ +992</option>
                      <option value="255">TZ +255</option>
                      <option value="66">TH +66</option>
                      <option value="228">TG +228</option>
                      <option value="690">TK +690</option>
                      <option value="676">TO +676</option>
                      <option value="1868">TT +1868</option>
                      <option value="216">TN +216</option>
                      <option value="90">TR +90</option>
                      <option value="7370">TM +7370</option>
                      <option value="1649">TC +1649</option>
                      <option value="688">TV +688</option>
                      <option value="256">UG +256</option>
                      <option value="380">UA +380</option>
                      <option value="971">AE +971</option>
                      <option value="44">GB +44</option>
                      <option value="1">US +1</option>
                      <option value="1">UM +1</option>
                      <option value="598">UY +598</option>
                      <option value="998">UZ +998</option>
                      <option value="678">VU +678</option>
                      <option value="39">VA +39</option>
                      <option value="58">VE +58</option>
                      <option value="84">VN +84</option>
                      <option value="1284">VG +1284</option>
                      <option value="1340">VI +1340</option>
                      <option value="681">WF +681</option>
                      <option value="212">EH +212</option>
                      <option value="967">YE +967</option>
                      <option value="38">YU +38</option>
                      <option value="260">ZM +260</option>
                      <option value="263">ZW +263</option>
                    </select>
                    <input
                      type="number"
                      id="phonenumber"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Phone Number"
                      required
                    />
                  </div>
                  <div className="relative w-full mb-2 group">
                    <input
                      type="text"
                      id="website"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Website"
                      required
                    />
                  </div>
                </div>

                <div className="font-bold gap-2 flex text-lg my-2 font-primary">
                  <img src={AgencyAddress} alt="fbtb2b" />
                  Agency Address
                </div>
                <div className="grid md:grid-cols-2 md:gap-6">
                  <div className="relative w-full mb-2 group">
                    <input
                      type="text"
                      id="addressline1"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Address Line 1"
                      required
                    />
                  </div>
                  <div className="relative w-full mb-2 group">
                    <input
                      type="text"
                      id="addressline2"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Address Line 2"
                      required
                    />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 md:gap-6">
                  <div className="relative w-full mb-2 group">
                    <CountrySelect
                      onChange={(e) => {
                        setCountryid(e.id);
                      }}
                      placeHolder="Select Country"
                    />
                  </div>
                  <div className="relative w-full mb-2 group">
                    <StateSelect
                      countryid={countryid}
                      onChange={(e) => {
                        setstateid(e.id);
                      }}
                      placeHolder="Select State"
                    />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 md:gap-6">
                  <div className="relative w-full mb-2 group">
                    <CitySelect
                      countryid={countryid}
                      stateid={stateid}
                      onChange={(e) => {
                        console.log(e);
                      }}
                      placeHolder="Select City"
                    />
                  </div>
                  <div className="relative w-full mb-2 group">
                    <input
                      type="number"
                      id="postalcode"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Zip/Postal Code"
                      required
                    />
                  </div>
                </div>

                <div className="grid items-center md:grid-cols-2  shadow-inner bg-gray-200 p-5 my-5 md:gap-6">
                  <div className="relative w-full mb-2 group">
                    <p className="font-bold text-sm">
                      How did you hear about us?
                    </p>
                    <div className="relative w-full my-2 group">
                      <select
                        id="countries"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      >
                        <option selected>Select Options</option>
                        <option>Arabian Travel Market</option>
                        <option>Google</option>
                        <option>ITB Asia</option>
                        <option>ITB Berlin</option>
                        <option>Marriott Referral</option>
                        <option>Referral</option>
                        <option>Social Media/Digital Campaigns</option>
                        <option>FBT Academy</option>
                        <option>FBT Marketing email / website</option>
                        <option>FBT Sales Team</option>
                        <option>Travel Publications/Websites</option>
                        <option>Word of Mouth</option>
                        <option>WTM LATAM</option>
                        <option>WTM London</option>
                        <option>YouTube</option>
                      </select>
                    </div>
                  </div>
                  {/* <ReCAPTCHA sitekey={process.env.REACT_APP_SITE_KEY} /> */}
                </div>
                <div className="flex flex-col justify-center flex-wrap  md:flex-row md:justify-between">
                  <div className="flex flex-col">
                    <span className="text-sm flex justify-center items-center gap-1 mb-4">
                      <input
                        id="default-checkbox"
                        type="checkbox"
                        value="Phone number and Email ID same as Admin Details"
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                      ></input>
                      <span>
                        I agree to the
                        <a href="/terms&condition" className="text-blue-700">
                          Terms and Conditions.
                        </a>
                      </span>
                    </span>
                  </div>
                </div>
                <div className="flex justify-center mt-5">
                  <div class="hover01 column">
                    <div>
                      <figure>
                        <button
                          type="submit"
                          className="rounded bg-secondary hover:bg-[rgb(255,133,0)] uppercase h-fit flex justify-center gap-1 text-base font-bold bg-primary text-white px-7 py-3.5"
                        >
                          Submit
                        </button>
                      </figure>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Login Modal */}
      <Modal
        show={openModal}
        size="md"
        defaultValue="center"
        onClose={() => setOpenModal(false)}
      >
        <Modal.Body className="relative">
          <button
            onClick={() => setOpenModal(false)}
            className="absolute top-[0] font-secondary z-10 right-[1%]"
          >
            <i className="ri-close-line text-4xl "></i>
          </button>
          <Login />
        </Modal.Body>
      </Modal>

      {/* After Registeration Sucessfull Confirmation Modal */}
      <Modal
        show={openConfirmationModal}
        size="md"
        defaultValue="center"
        onClose={() => setOpenConfirmationModal(false)}
      >
        <Modal.Body className="relative">
          <button
            onClick={() => setOpenConfirmationModal(false)}
            className="absolute top-[0] font-secondary z-10 right-[1%]"
          >
            <i className="ri-close-line text-4xl "></i>
          </button>
          <div className="flex flex-col justify-center items-center">
            <img src={Confirmation} alt="fbtb2b" className="max-w-16 mb-2" />
            <div className="font-primary">Registered Successfully!</div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Registeration;
